/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import { NewAppTab } from '../../components/tabs/newApp/NewAppTab';

const SamsungAndXiaomiPages = ({ handleClose, page }) => {
  return <NewAppTab handleClose={handleClose} page={page} />;
};

export default SamsungAndXiaomiPages;

SamsungAndXiaomiPages.propTypes = {
  handleClose: PropTypes.func.isRequired,
  page: PropTypes.oneOf(['google', 'samsung', 'xiaomi']).isRequired,
};
